import fetch from "@lib/fetch";
import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { settingsCacheKey } from "./constants";
import type { CompanySettingsPayload } from "./types";

export const getCompanySettings = reactQueryFetcherAdapter(
  settingsCacheKey,
  async (signal, companyId: string): Promise<CompanySettingsPayload> => {
    return fetch(`/companies/${companyId}/settings`, "GET", undefined, {
      signal,
    });
  }
);
